import * as React from 'react'
import {IFeatureLayerInfos} from '../../interfaces/reducers'
import Select from 'react-select'

interface Props {
  layerInfos: IFeatureLayerInfos
  visibleTables: {[id: string]: string}
  onChange: (id: string) => void
}

const TableSelector = (props: Props) => {
  const groupStyles = {
    display: 'flex',
    fontSize: 16,
    color: '#123846',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
  const groupBadgeStyles: React.CSSProperties = {
    backgroundColor: '#EBECF0',
    borderRadius: '2em',
    color: '#123846',
    display: 'inline-block',
    fontSize: 16,
    fontWeight: 'normal',
    lineHeight: '1',
    minWidth: 1,
    padding: '0.2em 0.5em',
    textAlign: 'center'
  }
  const formatGroupLabel = (data: any) => (
    <div style={groupStyles}>
      <span>{data.label}</span>
      <span style={groupBadgeStyles}>{data.options.length}</span>
    </div>
  )
  const getSelector = () => {
    const options: {label: string; options: {value: any; label: any}[]}[] = []
    for (const key in props.layerInfos) {
      const groupLabel = props.layerInfos[key].sourceDescription.groupLabel
      if (!options.find(o => o.label == groupLabel)) {
        options.push({label: groupLabel, options: []})
      }
      options.forEach(o => {
        if (o.label == groupLabel) {
          o.options.push({value: key, label: props.layerInfos[key].sourceDescription.sourceTitle})
        }
      })
    }
    let val = {}
    const key = Object.keys(props.visibleTables).length > 0 ? Object.keys(props.visibleTables)[0] : ''
    for (let i = 0; i < options.length; i++) {
      for (let j = 0; j < options[i].options.length; j++) {
        if (options[i].options[j].value == key) {
          val = options[i].options[j]
        }
      }
    }

    return (
      <Select
        className="w obj-select"
        value={[val]}
        onChange={(newValues: {value: any; label: any}) => {
          props.onChange(newValues.value)
        }}
        formatGroupLabel={formatGroupLabel}
        options={options}
      />
    )
  }

  if (Object.keys(props.layerInfos).length > 0) {
    const options: Array<JSX.Element> = []
    for (const key in props.layerInfos) {
      options.push(
        <option key={key} value={key}>
          {props.layerInfos[key].sourceDescription.sourceTitle}
        </option>
      )
    }
    return (
      <div
        style={{
          minHeight: '60px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center'
        }}
      >
        <div
          style={{
            maxWidth: '90%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%'
          }}
        >
          <div style={{fontSize: '16px', minWidth: '100px'}}>Изберете обект:</div>
          {getSelector()}
        </div>
      </div>
    )
  } else {
    return <div></div>
  }
}

export default TableSelector
